<template>
  <div>
    <PicturePopup
      v-show="picturePopupVisible"
      :picture="popupPicture"
      :hide="hidePicturePopup"
    ></PicturePopup>

    <div class="PhotoBlock" :class="{ Edit: showEditLink }" v-show="card.pictures.length || showEditLink">
      <div class="Zg">Фотографии и изображения</div>
      <div class="PhotoLine">
        <div class="PhotoBox" v-for="(pict, index) in card.pictures">
          <div class="PhotoSmall" v-bind:style='{ backgroundImage: `url(${pict.picture})` }' @click="showPicturePopup(pict)"></div>
          <div class="PhotoOpisanie" @click="showPicturePopup(pict)">{{ pict.title }}</div>
          <div class="EditBlock" v-if="showEditLink">
            <div class="GearBt" @click="showEditPicture(index)"></div>
            <div class="DelBt" @click="deletePicture(index)"></div>
          </div>
        </div>
      </div>
      <div class="AddBlock Picts" @click="showAddPicture" v-if="showEditLink">ДОБАВИТЬ</br>КАРТИНКУ</div>
    </div>

    <div class="PopUpAdd" id="PopUpP" v-show="editMode">
      <div class="PopUpFon" @click="offEditMode"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock" style="height: 360px;">
          <div class="PopUpName" style="color: #37bbd6; font-style: bold">{{ editPictureTitle() }}</div>
          <div class="PopUpClose" @click="offEditMode"></div>
          <div class="Rline3"></div>
          <form @submit.prevent="savePicture">
            <input type="file" class="FileLoad" ref="cardPictureFileInput" value="Выберете файл" @change="selectedNewPictureFile($event)" accept="image/*"></br>
            <textarea maxlength='120' class='FileOpisForma' placeholder="Описание к картинке в 120 знаков." v-model="editPicture().title"></textarea>
            <input type="submit" class="BtFileLoad" value="ЗАГРУЗИТЬ">
          </form>
          <div class="FLError" v-show="newPictureError">{{ newPictureError }}</div>
          <!-- <div class="Login">Ваш email или телефон</div>
          <div class="Pass">********</div>
          <div class="BtEnter">Войти</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pick } from 'lodash';
import PicturePopup from "@/components/card/PicturePopup.vue";

export default {
  components: {
    PicturePopup
  },
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function
  },
  data() {
    return {
      editMode: false,
      newPicture: {},
      newPictureFile: null,
      newPictureError: null,
      editPictureIndex: -1,
      picturePopupVisible: false,
      popupPicture: {}
    };
  },
  methods: {
    showPicturePopup(pict) {
      this.popupPicture = pict;
      this.picturePopupVisible = true;
    },
    hidePicturePopup() {
      this.popupPicture = {};
      this.picturePopupVisible = false;
    },
    onEditMode() {
      this.editMode = true;
      console.log('Card component onEditMode', this.editMode);
    },
    offEditMode() {
      this.editMode = false;
      console.log('Card component offEditMode', this.editMode);
    },
    showAddPicture() {
      this.editPictureIndex = -1;
      this.newPictureFile = null;
      this.$refs.cardPictureFileInput.value = null;
      this.newPictureError = null;
      this.onEditMode();
    },
    showEditPicture(index) {
      this.editPictureIndex = index;
      this.newPictureFile = null;
      this.$refs.cardPictureFileInput.value = null;
      this.newPictureError = null;
      console.log('Card component showeditPicture', index, this.editPicture());
      this.onEditMode();
    },
    editPicture() {
      return this.editPictureIndex == -1 ? this.newPicture : this.card.pictures[this.editPictureIndex];
    },
    editPictureTitle() {
      return this.editPictureIndex == -1 ? "ДОБАВИТЬ КАРТИНКУ" : "ИЗМЕНИТЬ КАРТИНКУ";
    },
    selectedNewPictureFile(event) {
      console.log('selectedNewPictureFile', event, event.target.files[0]);
      if (event.target.files[0]) {
        this.newPictureError = null;
        this.newPictureFile = event.target.files[0];
      } else {
        // this.newPictureError = "Выберете файл";
        this.newPictureFile = null;
      }
      console.log('selectedNewPictureFile', this.newPictureFile);
    },
    savePicture() {
      console.log('savePicture', this.newPictureFile);
      // if (!this.newPictureFile) {
      //   this.newPictureError = "Выберете файл";
      //   return;
      // }

      // console.log('savePicture', this.editPicture());

      const formData = new FormData();
      const prefix = "card[pictures][]";
      if (this.editPicture().id)
        formData.append(`${prefix}[id]`, this.editPicture().id);
      formData.append(`${prefix}[title]`, this.editPicture().title);
      if (this.newPictureFile)
        formData.append(`${prefix}[picture]`, this.newPictureFile);
      console.log('formData', formData);

      this.saveData(formData, this.offEditMode, ['pictures']);
      if (!this.editPicture().id) this.newPicture = {};
    },
    deletePicture(index) {
      const file = pick(this.card.pictures[index], ['id']);
      file['_destroy'] = '1';
      console.log('deletePicture', file);
      const params = {pictures: [file]};
      this.editPictureIndex = -1;
      this.saveData({card: params}, false, ['pictures']);
    },
  }
};
</script>

<style>
.PopUpPict{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: #323938;
  border-top: 1px solid #ccc; */
  z-index: 10;
}

.PhotoShow{
  position: relative;
  margin: 60px auto;
  width: 90%;
  height: 80%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border: 0px solid #666;
}

.PhotoTxt{
  position: relative;
  margin: 0px auto;
  width: 90%;
  bottom: 30px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  text-align: center;
  color: #999;
  border: 0px solid #333;
}
</style>
